import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DocumentVisibilityKind, DocumentVisibilityKindToString } from '../../../common/model/const/enum';
import { PropertyDocumentService } from '../../service/data/property-document-service';
import { PropertyDocument } from '../../model/property-document';

@Component({
    selector: 'app-property-change-document-visibility',
    templateUrl: './change-property-document-visibility.component.html',
    styleUrls: ['./change-property-document-visibility.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChangePropertyDocumentVisibilityComponent implements OnInit, OnDestroy {
  constructor(
    private _dataService: PropertyDocumentService,
    private _modalService: ActionWindowService,
    cf: FormControlExFactory,
    fb: FormBuilder
  ) {
    this.form = fb.group({
      visibility: cf.createMandatory('COMMON.DISPLAYED_FOR', DocumentVisibilityKind.LandlordPages),
      id: cf.createHidden(''),
    });
  }

  linkedPropertyDocument: PropertyDocument;
  private sub: Subscription;

  private _dataContext: {
    linkedPropertyDocuments?: PropertyDocument[];
  };

  get dataContext(): {
    linkedPropertyDocuments?: PropertyDocument[];
  } {
    return this._dataContext;
  }
  set dataContext(value: { linkedPropertyDocuments?: PropertyDocument[] }) {
    this._dataContext = value;
    if (value.linkedPropertyDocuments instanceof Array) {
      if (this.dataContext.linkedPropertyDocuments && this.dataContext.linkedPropertyDocuments.length == 1) {
        this.linkedPropertyDocument = this.dataContext.linkedPropertyDocuments[0];
        this.form.controls['id'].setValue(this.linkedPropertyDocument.id);
        this.form.controls['visibility'].setValue(DocumentVisibilityKind.LandlordPages);
      }
    }
  }
  readonly form: FormGroup;
  visibilityLevels = [
    { name: DocumentVisibilityKindToString(DocumentVisibilityKind.LandlordPages), value: DocumentVisibilityKind.LandlordPages },
    {
      name: DocumentVisibilityKindToString(DocumentVisibilityKind.LandlordPagesAndTenantPages),
      value: DocumentVisibilityKind.LandlordPagesAndTenantPages,
    },
  ];

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  cancel() {
    this._modalService.close();
  }

  ngOnInit() {}

  onSubmit() {
    if (this.form.invalid) return;

    this.form.disable();

    if (this.sub) {
      this.sub.unsubscribe();
    }

    if (this.linkedPropertyDocument) {
      this.sub = this._dataService.changeVisibilityLevel(this.form.value).subscribe(
        res => {
          this._modalService.complete(res);
          this._modalService.close();
        },
        error => this.form.enable()
      );
      return;
    }
  }
}
